import React from 'react'
import { Link } from "react-router-dom";

const SubservientChargesMcaUI = ({ context, account, subservientMCA, onShowDetailsClick, showDetails }) =>
  <div id='subservientMca' className='g_m_top_200'>
    <span className='g_flex_h'>
      <b className='g_large'>Subservient using MCA</b>
      <Link to='#' onClick={onShowDetailsClick}>Details</Link>
    </span>
    <table className='g_table'>
      <thead className='g_sticky'><tr>
        <td className='g_text_center'><b>Particulars</b></td>
        <td className='g_text_center'><b>From last<br />audited year</b></td>
        <td className='g_text_center'><b>YTD</b></td>
        <td className='g_text_center'><b>RV %</b></td>
        <td className='g_text_center'><b>RV Amount</b></td>
      </tr></thead>
      <tbody>
        <tr><td colSpan='8'><b className='g_m_top_200'>Non-current Assets</b></td></tr>
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='tangibleAssets' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='otherTangibleAssets' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='intangibleAssets' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='capitalWorkInProgress' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='intangibleAssetsUnderDevelopment' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='nonCurrentInvestments' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='longTermLoansAndAdvances' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='deferredTaxAssets' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='otherNonCurrentAssets' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalNonCurrentAssets' />
        <tr><td colSpan='8'><b className='g_m_top_200'>Current Assets</b></td></tr>
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='currentInvestments' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='inventories' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='shortTermLoansAndAdvances' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='tradeReceivables' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='cashAndBankBalances' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='otherCurrentAssets' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalCurrentAssets' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalAssets' />
        <tr><td colSpan='8'><b>Non-current Liabilities</b></td></tr>
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='securedLongTermBorrowings' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='unsecuredLongTermBorrowings' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='longTermProvisions' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='deferredTaxLiabilities' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='otherNonCurrentLiabilities' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalNonCurrentLiabilities' />
        <tr><td colSpan='8'><b>Current Liabilities</b></td></tr>
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='securedShortTermBorrowings' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='tradePayables' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='shortTermProvisions' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='currentDeferredTaxLiabilities' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='otherCurrentLiabilities' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalCurrentLiabilities' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalLiabilities' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='totalChargeValue' />
        {/* <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='gstCashProfit' />
        <RowUI subservientMCA={subservientMCA} showDetails={showDetails} name='promoterContribution' />
        <TotalUI subservientMCA={subservientMCA} total={true} showDetails={showDetails} name='finalChargeValue' /> */}
      </tbody>
    </table>
  </div>

const RowUI = ({ subservientMCA, total, name, showDetails }) =>
  <>
    {
      subservientMCA[name + 'Item'] &&
      <>
        <tr className={total && 'g_table_total'}>
          <td><Desc name={name} /></td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].auditedValueF2}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].currentValueF2}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].rvPercent}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].rvAmountF2}
          </td>
        </tr>
        <tr>
          {
            subservientMCA[name + 'Item'].formula && showDetails &&
            <td colSpan='5' className='g_muted g_small'>
              {subservientMCA[name + 'Item'].formula}
            </td>
          }
        </tr>
      </>
    }
  </>

const TotalUI = ({ subservientMCA, total, name, showDetails }) =>
  <>
    {
      subservientMCA[name + 'Item'] &&
      <>
        <tr className={total && 'g_table_total'}>
          <td><Desc name={name} /></td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].auditedValueF2}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].currentValueF2}
          </td>
          <td></td>
          <td className='g_text_right g_m_left_100'>
            {subservientMCA[name + 'Item'].rvAmountF2}
          </td>
        </tr>
        <tr>
          {
            subservientMCA[name + 'Item'].formula && showDetails &&
            <td colSpan='5' className='g_muted g_small'>
              {subservientMCA[name + 'Item'].formula}
            </td>
          }
        </tr>
      </>
    }
  </>


const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'equityShareCapital':
          return 'Equity Share Capital'
        case 'otherEquity':
          return 'Other Equity'
        case 'reserveSurplus':
          return 'Reserve & Surplus'
        case 'others':
          return 'Others'
        case 'totalEquity':
          return 'Total Equity'
        case 'securedLongTermBorrowings':
          return 'Secured Long-term Borrowings'
        case 'unsecuredLongTermBorrowings':
          return 'Unsecured Long-term Borrowings'
        case 'longTermProvisions':
          return 'Long Term Provisions'
        case 'deferredTaxLiabilities':
          return 'Deferred Tax Liabilities'
        case 'otherNonCurrentLiabilities':
          return 'Other Non-Current Liabilities'
        case 'totalNonCurrentLiabilities':
          return 'Total Non-Current Liabilities'
        case 'securedShortTermBorrowings':
          return 'Secured Short-term Borrowings'
        case 'tradePayables':
          return 'Trade Payables'
        case 'shortTermProvisions':
          return 'Short Term Provisions'
        case 'currentDeferredTaxLiabilities':
          return 'Current Deferred Tax Liabilities'
        case 'otherCurrentLiabilities':
          return 'Other Current Liabilities'
        case 'totalCurrentLiabilities':
          return 'Total Current Liabilities'
        case 'totalLiabilities':
          return 'Total Liabilities'
        case 'totalEquityAndLiabilities':
          return 'Total Equity and Liabilities'

        case 'tangibleAssets':
          return 'Tangible Assets'
        case 'otherTangibleAssets':
          return 'Other Tangible Assets'
        case 'intangibleAssets':
          return 'Intangible Assets'
        case 'capitalWorkInProgress':
          return 'Capital Work in Progress'
        case 'intangibleAssetsUnderDevelopment':
          return 'Intangible Assets under Development'
        case 'netFixedAssets':
          return 'Net Fixed Assets'
        case 'nonCurrentInvestments':
          return 'Non-current Investments'
        case 'longTermLoansAndAdvances':
          return 'Long Term Loans & Advances'
        case 'deferredTaxAssets':
          return 'Deferred Tax Assets'
        case 'otherNonCurrentAssets':
          return 'Other Non-Current Assets'
        case 'totalNonCurrentAssets':
          return 'Total Non-current Assets'
        case 'currentInvestments':
          return 'Current Investments'
        case 'inventories':
          return 'Inventories'
        case 'shortTermLoansAndAdvances':
          return 'Short Term Loans & Advances'
        case 'tradeReceivables':
          return 'Trade Receivables'
        case 'cashAndBankBalances':
          return 'Cash and Bank Balances'
        case 'otherCurrentAssets':
          return 'Other Current Assets'
        case 'totalCurrentAssets':
          return 'Total Current Assets'
        case 'totalAssets':
          return 'Total Assets'
        case 'totalChargeValue':
          return 'Total Charge Value'
        case 'gstCashProfit':
          return 'GST cash profit'
        case 'promoterContribution':
          return 'Promoter contribution'
        case 'finalChargeValue':
          return 'Final Charge Value'
        default:
          return name
      }
    })()}
  </span>

export default SubservientChargesMcaUI
